import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { PlayerNotifyComponent } from '@splixer/player-ui';
import { RouterOutlet } from '@angular/router';
import { KexpHeaderComponent } from '../../../core/layout/header/kexp-header.component';
import {SplixerLayoutControlService, StationManagerService} from '@splixer/player';
import { NgClass } from '@angular/common';
import {KexpFooterComponent} from "../../../core/layout/footer/kexp-footer.component";

@Component({
  selector: 'kexp-root-page',
  templateUrl: 'root.page.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PlayerNotifyComponent,
    RouterOutlet,
    KexpHeaderComponent,
    NgClass,
    KexpFooterComponent,
  ]
})
export class KexpRootPage {
  protected layoutController = inject(SplixerLayoutControlService);
  protected station = inject(StationManagerService);
}
